import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { AuthProvider } from "./components/AuthWrapper";
import AuthWrapper from "./components/AuthWrapper";
import { AppRouter } from "./components/Router";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  </AuthProvider>
);
